import { Globe, Mail, MapPin, Phone } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { CONTACT } from "../data/content";

export default function Contact() {
  return (
    <main data-testid="contact-page" className="bg-[#070C14] text-white">
      <PageHero
        testId="contact-hero"
        eyebrow="Contact"
        title="Direct channels for serious energy conversations."
        description="Reach CLACH Global Services Limited at its Lagos office, by phone, by email, or through the company website."
        image="/assets/page_18_img_1.jpeg"
        imageAlt="Offshore platform at night"
      />

      <section data-testid="contact-details-section" className="mx-auto grid max-w-7xl gap-6 px-4 py-20 sm:px-8 lg:grid-cols-2 lg:px-10">
        <Reveal className="rounded-3xl border border-white/10 bg-[#0D131F] p-8 sm:p-10 lg:col-span-2">
          <MapPin className="text-amber-400" size={30} />
          <h2 className="mt-8 font-heading text-3xl font-semibold">Our offices</h2>
          <div className="mt-8 grid gap-5 md:grid-cols-2">
            {CONTACT.offices.map((office) => {
              const officeId = office.city.toLowerCase();
              const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(office.address)}`;
              return (
                <div key={office.city} className="rounded-3xl border border-white/10 bg-white/[0.04] p-6" data-testid={`office-${officeId}`}>
                  <h3 className="font-heading text-2xl font-semibold text-white">{office.city}</h3>
                  <p className="mt-4 text-lg leading-8 text-slate-300" data-testid={`contact-address-${officeId}`}>{office.address}</p>
                  <a href={mapUrl} target="_blank" rel="noreferrer" data-testid={`contact-map-link-${officeId}`} className="mt-6 inline-flex rounded-full border border-blue-400/40 px-5 py-3 font-mono text-xs uppercase tracking-[0.2em] text-blue-300 transition-colors hover:border-amber-400 hover:text-amber-300">
                    Open map
                  </a>
                </div>
              );
            })}
          </div>
        </Reveal>
        <Reveal delay={0.1} className="rounded-3xl border border-white/10 bg-[#0D131F] p-8 sm:p-10">
          <Phone className="text-amber-400" size={30} />
          <h2 className="mt-8 font-heading text-3xl font-semibold">Phone line</h2>
          <div className="mt-5 space-y-3">
            {CONTACT.phones.map((phone) => (
              <a key={phone} href={`tel:${phone.replace(/\s/g, "")}`} data-testid={`contact-phone-${phone.replace(/[^0-9]/g, "")}`} className="block text-lg text-slate-300 transition-colors hover:text-amber-300">
                {phone}
              </a>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.15} className="rounded-3xl border border-white/10 bg-[#0D131F] p-8 sm:p-10">
          <Mail className="text-amber-400" size={30} />
          <h2 className="mt-8 font-heading text-3xl font-semibold">Email</h2>
          <a href={`mailto:${CONTACT.email}`} data-testid="contact-email-link" className="mt-5 block text-lg text-slate-300 transition-colors hover:text-amber-300">
            {CONTACT.email}
          </a>
        </Reveal>
        <Reveal delay={0.2} className="rounded-3xl border border-white/10 bg-[#0D131F] p-8 sm:p-10 lg:col-span-2">
          <Globe className="text-amber-400" size={30} />
          <h2 className="mt-8 font-heading text-3xl font-semibold">Website</h2>
          <a href={CONTACT.websiteUrl} target="_blank" rel="noreferrer" data-testid="contact-website-link" className="mt-5 block text-lg text-slate-300 transition-colors hover:text-amber-300">
            {CONTACT.website}
          </a>
        </Reveal>
      </section>

      <section data-testid="contact-note-section" className="mx-auto max-w-7xl px-4 pb-24 sm:px-8 lg:px-10">
        <Reveal className="overflow-hidden rounded-3xl border border-amber-400/20 bg-gradient-to-r from-amber-400/12 via-blue-500/10 to-transparent p-8 sm:p-10">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-amber-300">Contact mode</p>
          <h2 className="mt-4 font-heading text-3xl font-bold">Details only, as requested.</h2>
          <p className="mt-4 max-w-2xl text-sm leading-7 text-slate-300">This page intentionally displays direct contact information without a form, keeping every enquiry channel simple and immediate.</p>
        </Reveal>
      </section>
    </main>
  );
}
